import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class DashboardNotificationService {
 
  public notificationList: any;
  private observableNotifications: BehaviorSubject<string[]>;
  isNotificationActive: boolean = false;
  constructor(public http: HttpClient,
  ) {
    this.notificationList = new Array();
    this.observableNotifications = <BehaviorSubject<string[]>>new BehaviorSubject([]);
  }
  

  /**
   * Set and get the Notiifcation
   */
  set notifications(value) {
    this.notificationList.push(value);
    this.observableNotifications.next(Object.assign({}, this.notificationList));
  }

  get notifications(): any | Observable<string> {
    return this.observableNotifications.asObservable();
  }

  addNotificationInList(value) {
    this.notifications = value;
    this.isNotificationActive = true;
  }
}
